import { createContext } from 'react';

import { HistogramAnnotationsConfigProps } from '../components/annotations-histogram/types.js';

export const defaultConfig: HistogramAnnotationsConfigProps = { tracks: [] };

export const HistogramAnnotationsConfigContext =
  createContext<HistogramAnnotationsConfigProps>(defaultConfig);

HistogramAnnotationsConfigContext['displayName'] =
  'HistogramAnnotationsContext';
